import ProgressIndicatorMultiIndicator from './ProgressIndicatorMultiIndicator';
import ProgressIndicatorSingleIndicator from './ProgressIndicatorSingleIndicator';
import useProgressIndicator from './useProgressIndicator';

export interface ProgressIndicatorItemSingle {
  type: 'single';
  active: boolean;
}

export interface ProgressIndicatorItemMulti {
  type: 'multi';
  substeps: ProgressIndicatorItemSingle[];
}

export type ProgressIndicatorItem =
  | ProgressIndicatorItemSingle
  | ProgressIndicatorItemMulti;

export interface ProgressIndicatorProps {
  items: ProgressIndicatorItem[];
  lastPassed?: boolean;
}

const ProgressIndicator: React.FunctionComponent<ProgressIndicatorProps> =
  function ({ items, lastPassed }) {
    const { modifiedItems } = useProgressIndicator(items, lastPassed);
    return (
      <div className="flex flex-row w-full">
        {modifiedItems.map(({ key, ...item }) => {
          if (item.type === 'multi')
            return <ProgressIndicatorMultiIndicator key={key} {...item} />;
          return <ProgressIndicatorSingleIndicator key={key} {...item} />;
        })}
      </div>
    );
  };

export default ProgressIndicator;
